import o from "./_cloneArrayBuffer.js";
function u(f, e) {
  var n = e ? o(f.buffer) : f.buffer;
  return new f.constructor(n, f.byteOffset, f.length);
}
export {
  u as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_cloneTypedArray.js
// module id = 910
// module chunks = 67